import { Link, useNavigate } from '@tanstack/react-router';

import { ApiForm, Field, Submit, TextInput, useApiForm } from '../../shared/form';
import { register, registerSchema, type TRegister } from '../../entities/session';
import { AuthScreen } from './ui/auth-screen';

export const RegisterPage = () => {
  const navigate = useNavigate();

  const api = useApiForm<TRegister>({
    schema: registerSchema,
    defaultValues: { organizationName: '', name: '', email: '', password: '' },
    onSubmit: async (values) => {
      await register(values);
      await navigate({ to: '/flows' });
    },
  });

  return (
    <AuthScreen
      title="Create account"
      description="Your account comes with an organization. Sources, events and settings all live inside it; invite people once it exists."
      footer={
        <>
          Already have an account?{' '}
          <Link to="/sign-in" className="text-accent">
            Sign in
          </Link>
        </>
      }
    >
      <ApiForm api={api}>
        <Field<TRegister>
          name="organizationName"
          label="Organization name"
          hint="You can rename it later in settings"
        >
          <TextInput placeholder="RawNodes" />
        </Field>

        <Field<TRegister> name="name" label="Your name">
          <TextInput autoComplete="name" placeholder="Pavel" />
        </Field>

        <Field<TRegister> name="email" label="Work email" hint="We will send a confirmation link">
          <TextInput type="email" autoComplete="email" placeholder="pavel@rawnodes.dev" />
        </Field>

        <Field<TRegister> name="password" label="Password">
          <TextInput
            type="password"
            autoComplete="new-password"
            placeholder="8+ characters, a letter and a number"
          />
        </Field>

        <Submit waitingLabel="Creating">Create account</Submit>
      </ApiForm>
    </AuthScreen>
  );
};
